import { render, staticRenderFns } from "./Redeem09_1.vue?vue&type=template&id=5edcd42c&scoped=true&"
import script from "./Redeem09_1.vue?vue&type=script&lang=js&"
export * from "./Redeem09_1.vue?vue&type=script&lang=js&"
import style0 from "./Redeem09_1.vue?vue&type=style&index=0&id=5edcd42c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edcd42c",
  null
  
)

export default component.exports